<template>
  <!-- ==================== 페이지 머리 (화면명 + 작업 탭 + actions) ==================== -->
  <div class="app-page-title-bar" :class="{ 'app-page-title-bar--solo': !$slots.tabs }">
    <h1 class="app-page-title"><slot name="title">{{ title }}</slot></h1>
    <slot name="tabs" />
    <div class="app-page-title-bar__actions">
      <slot name="actions" />
    </div>
  </div>
</template>

<script>
/**
 * @component PageHeader
 * @description 공통 페이지 머리 부품 (SURINP-688) — 화면 제목(h1)·작업 탭 줄·우측 actions 를 한 줄로 그립니다.
 * 제목은 메뉴 마스터 이름(활성 탭 제목)이고, 작업 탭 줄(tabs 슬롯)은 탭이 2개 이상일 때만 넘겨받아
 * 제목 옆에 같은 글자의 탭 상자가 겹쳐 보이지 않게 합니다. 레이아웃 스타일은 전역 layout.css 의 app-page-title-bar 를 씁니다.
 */
export default {
  name: 'PageHeader',
  // ── Props ──
  props: {
    /** 화면 제목 (title 슬롯이 없을 때 표시) */
    title: { type: String, default: '' }
  }
}
</script>

<style scoped>
/* 작업 탭 줄이 없을 때도 actions(PartnerSelect 등)는 우측 끝에 둔다 — 평소에는 탭 줄(flex:1)이 밀어 준다 */
.app-page-title-bar--solo .app-page-title-bar__actions {
  margin-left: auto;
}

/* 비-PC 는 화면명을 MobileHeader 가 그리고 h1 을 숨기므로, 작업 탭 줄도 없으면 빈 띠가 된다 */
@media (max-width: 1279px) {
  .app-page-title-bar--solo {
    display: none;
  }
}
</style>
